import { getAuthsAppRouter } from '../Common/Components/Routes/Routes';
import { loadApp } from '../Common/Utilities/App.js';
import AuthsRoutes from './AuthsRoutes.jsx';
import AuthsStore from './Redux/AuthsStore';

loadApp(getAuthsAppRouter(AuthsRoutes, AuthsStore));
